import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import styles2 from "./RegisterPage.module.css";
import styles from "./RegisterPage2.module.css";

import logo2 from "../../assets/house-icon-red.png";
import { BASE_URL } from "../../App";

export default function LoginPage() {
    const navigate = useNavigate();
    const [msg, setMsg] = useState({ type: "", text: "" });

    const [formData, setFormData] = useState({
        name: "",
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const validateForm = () => {
        const { name, username, email, password, confirmPassword } = formData;

        if (!name.trim()) {
            setMsg({ type: "error", text: "Full Name is required" });
            return false;
        }

        if (!username.trim()) {
            setMsg({ type: "error", text: "Username is required" });
            return false;
        }

        const usernameRegex = /^[a-zA-Z0-9_]+$/;
        if (!usernameRegex.test(username)) {
            setMsg({
                type: "error",
                text: "Username can only contain letters, numbers, and _",
            });
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setMsg({
                type: "error",
                text: "Please enter a valid email address.",
            });
            return false;
        }

        if (password.length < 6) {
            setMsg({
                type: "error",
                text: "Password must be at least 6 characters long",
            });
            return false;
        }

        const specialCharsRegex = /[^a-zA-Z0-9\s]/;
        if (!specialCharsRegex.test(password)) {
            setMsg({
                type: "error",
                text: "Password must contain at least 1 special character",
            });
            return false;
        }

        const capitalLetterRegex = /[A-Z]/;
        if (!capitalLetterRegex.test(password)) {
            setMsg({
                type: "error",
                text: "Password must contain at least 1 capital letter",
            });
            return false;
        }

        if (password !== confirmPassword) {
            setMsg({ type: "error", text: "Passwords do not match" });
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const fd = new FormData();
        fd.append("name", formData.name);
        fd.append("username", formData.username);
        fd.append("email", formData.email);
        fd.append("password", formData.password);
        fd.append("passC", formData.confirmPassword);

        try {
            const response = await fetch(`${BASE_URL}/backend/register.php`, {
                method: "POST",
                body: fd,
            });

            const result = await response.json();

            if (response.ok) {
                if (result.message === "email already registered") {
                    setMsg({ type: "error", text: "That email is already registered" });
                } else if (result.message === "username already taken") {
                    setMsg({ type: "error", text: "That username is already taken" });
                } else if (result.message !== "OK") {
                    setMsg({ type: "error", text: result.message });
                } else {
                    // Success message before redirecting
                    setMsg({ type: "success", text: "Registration successful! Redirecting to login..." });
                    // Give a moment for the user to see the success message before navigating
                    setTimeout(() => navigate("/login"), 1000); 
                }
            } else {
                setMsg({ type: "error", text: result.message });
            }
        } catch (err) {
            setMsg({
                type: "error",
                text: "An unexpected error occurred. Please try again later",
            });
        }
    };

    // NEW: useEffect hook to dismiss messages after 5 seconds
    useEffect(() => {
        if (msg.text && msg.type === "error") {
            const timer = setTimeout(() => {
                setMsg({ type: "", text: "" }); // Clear the message
            }, 5000); // 5000 milliseconds = 5 seconds

            // Cleanup function to clear the timeout if the component unmounts or msg changes
            return () => clearTimeout(timer);
        }
        // Note: Success messages are handled within handleSubmit with a 1-second delay before navigation.
    }, [msg]);

    return (
        <div className={styles2.component}>
            <div className={styles2.inner}>
                <div className={styles2.headerL}>
                    <img src={logo2} width={60} height={60} />
                    <h1 className={styles2.topText}>Welcome to</h1>
                    <h1 className={styles2.bottomText}>HomeMate</h1>
                </div>

                <div className={styles2.formBlockR}>
                    <form className={styles.formContent} onSubmit={handleSubmit}>
                        <h2 className={styles.signUp}>Sign Up</h2>

                        <div className={styles.inputRect}>
                            <input
                                className={styles.textBoxes}
                                type="text"
                                placeholder="Full Name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.inputRect}>
                            <input
                                className={styles.textBoxes}
                                type="text"
                                placeholder="Username"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.inputRect}>
                            <input
                                className={styles.textBoxes}
                                type="text"
                                placeholder="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.inputRect}>
                            <input
                                className={styles.textBoxes}
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.inputRect}>
                            <input
                                className={styles.textBoxes}
                                type="password"
                                placeholder="Confirm Password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <input className={styles.submit} type="submit" value="Sign Up" />

                        <a className={styles.login} href={`${BASE_URL}/#/login`}>
                            Already Have An Account? Log In
                        </a>

                        {msg.text && (
                            <div
                                className={
                                    msg.type === "success"
                                        ? styles.alertSuccess
                                        : styles.alertError
                                }
                                role="status"
                            >
                                <p>{msg.text}</p>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
}